import { z } from "zod";
import { authHeadersSchema, initContract } from "./base";
import { apiErrorSchema } from "./errors";
import { usageRecordRangeSchema } from "./zero-usage-record";

const c = initContract();

const memberUsageSchema = z.object({
  userId: z.string(),
  email: z.string(),
  inputTokens: z.number(),
  outputTokens: z.number(),
  cacheReadInputTokens: z.number(),
  cacheCreationInputTokens: z.number(),
  creditsCharged: z.number(),
});

const usageMembersResponseSchema = z.object({
  period: z
    .object({
      start: z.string(),
      end: z.string(),
    })
    .nullable(),
  members: z.array(memberUsageSchema),
});

/**
 * Zero contract for GET /api/zero/usage/members
 */
export const zeroUsageMembersContract = c.router({
  get: {
    method: "GET",
    path: "/api/zero/usage/members",
    headers: authHeadersSchema,
    query: z.object({
      range: usageRecordRangeSchema.default("billingPeriod"),
      tz: z.string().default("UTC"),
    }),
    responses: {
      200: usageMembersResponseSchema,
      400: apiErrorSchema,
      401: apiErrorSchema,
      403: apiErrorSchema,
      500: apiErrorSchema,
    },
    summary: "Get per-member usage for a selected period",
  },
});

export type ZeroUsageMembersContract = typeof zeroUsageMembersContract;

// Inferred types from Zod schemas
export type MemberUsage = z.infer<typeof memberUsageSchema>;
export type UsageMembersResponse = z.infer<typeof usageMembersResponseSchema>;
